import { useCallback, useEffect } from 'react';
import { Routes, Route, useMatch, useNavigate, useLocation, matchRoutes } from 'react-router-dom';

import ManageMyApps from '@pages/myAppManager/myApps';
import MyAppManager from '@pages/myAppManager/myApps/myAppManager';

import Integration from '@pages/myAppManager/integration';

const AppManagerRoutes = () => {
  const navigate = useNavigate();

  const location = useLocation();

  const matchMyApps = useMatch('/myApps');

  useEffect(() => {
    if (location) {
      const matchroutesTest = matchRoutes([{ path: '/appManager/myApps/*' }], location);
    }
  }, [location]);

  const onClickNavigate = useCallback(
    (path: string) => {
      if (path === 'myApps') {
        navigate('/appManager/myApps');
      } else if (path === 'integration') {
        navigate('/appManager/integration');
      }
    },
    [navigate]
  );
  return (
    <>
      <div className="tab-menu">
        <ul className="tab-wrap">
          <li className={`tab-list ${location?.pathname.indexOf('/myApps') > -1 ? 'active' : ''} `}>
            <button type="button" className="tab-btn" onClick={() => onClickNavigate('myApps')}>
              My Apps
            </button>
          </li>
          <li className={`tab-list ${location?.pathname.indexOf('/integration') > -1 ? 'active' : ''}`}>
            <button
              type="button"
              className="tab-btn"
              onClick={
                // () => onClickNavigate('integration')
                () => alert('This Service will be open soon')
              }
            >
              Integration
            </button>
          </li>
        </ul>
      </div>
      <Routes>
        <Route path="/myApps" element={<ManageMyApps />} />
        <Route path="/myApps/:step" element={<MyAppManager />} />
        <Route path="/integration" element={<Integration />}></Route>
      </Routes>
    </>
  );
};

export default AppManagerRoutes;
